import { MockCard, MockButton, MockSearchInput, MockSelect } from '../../components/mockups/MockUI'
import { MockBadge } from '../../components/mockups/MockBadge'
import { MockTable, MockAgGridHeader } from '../../components/mockups/MockTable'

export function QueueOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Очередь квот
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Основной рабочий экран закупщика. Показывает все позиции, по которым нужно найти цены у
          поставщиков. Доступна через пункт «Очередь квот» в меню (иконка корзины).
        </p>
      </div>

      <MockCard>
        <div className="flex items-center justify-between mb-3">
          <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Очередь квот
          </span>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <MockButton>Мне</MockButton>
          <MockButton variant="secondary">В очереди</MockButton>
          <MockButton variant="secondary">Просроченные</MockButton>
          <MockSearchInput placeholder="Поиск по партномеру..." />
          <MockSelect label="" value="Все категории" />
          <MockSelect label="" value="Все приоритеты" />
        </div>
      </MockCard>

      <MockAgGridHeader
        columns={[
          'Кат.',
          'Код клиента',
          'Заявка',
          'Партномер',
          'Бренд',
          'Кол-во',
          'Приоритет',
          'Дедлайн',
          'Статус',
          'Назначена',
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Как работать с очередью:
          </div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Откройте очередь — увидите все позиции с матрицей «Китай» или «Производители»</li>
            <li>Нажмите «Мне» — отфильтруйте назначенные вам позиции</li>
            <li>Выберите позиции чекбоксами → «Скачать запрос» → Excel-файл</li>
            <li>Отправьте файл поставщикам по email</li>
            <li>Когда поставщик ответит → «Загрузить ответ» → импорт цен из Excel</li>
          </ol>
        </div>
      </MockCard>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Шапка таблицы и верхний блок фильтров закреплены — при прокрутке длинного списка они
        остаются видимыми. Таблица поддерживает бесконечную подгрузку (infinite scroll).
      </p>
    </div>
  )
}

export function QueueFilters() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Фильтры очереди
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Быстрые кнопки-фильтры позволяют переключаться между режимами просмотра.
        </p>
      </div>

      <MockTable
        caption="Кнопки-фильтры"
        columns={[{ header: 'Кнопка' }, { header: 'Что показывает' }]}
        rows={[
          [<MockButton>Мне</MockButton>, 'Только позиции, назначенные на вас'],
          [
            <MockButton variant="secondary">В очереди</MockButton>,
            'Все позиции со статусом «В работе» или «Новая»',
          ],
          [
            <MockButton variant="secondary">Просроченные</MockButton>,
            'Позиции с истёкшим дедлайном заявки',
          ],
          [
            <MockButton variant="secondary">Нужна инфо</MockButton>,
            'Позиции со статусом «Нужна информация»',
          ],
          [
            <MockButton variant="secondary">Доработка</MockButton>,
            'Позиции со статусом «На доработке»',
          ],
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Дополнительные фильтры:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="font-medium">Поиск</span> — ищет по партномеру и бренду (с задержкой
              400мс)
            </li>
            <li>
              <span className="font-medium">Категория</span> — A/B/C клиента
            </li>
            <li>
              <span className="font-medium">Приоритет</span> — HIGH/MEDIUM/LOW позиции
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function QueueState() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Состояния позиций
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          У позиции есть персональное (per-user) состояние закупщика — параллельная шкала к общему
          статусу заявки. У каждого закупщика своё состояние по той же позиции, потому что несколько
          закупщиков могут работать с ней одновременно.
        </p>
      </div>

      <MockTable
        caption="7 состояний (per-user)"
        columns={[{ header: 'Состояние' }, { header: 'Когда ставится' }]}
        rows={[
          [<MockBadge color="blue">Новая</MockBadge>, 'NEW — позиция только появилась в очереди'],
          [
            <MockBadge color="blue">Запрос отправлен</MockBadge>,
            'REQUESTED — автоматически при «Скачать запрос» из очереди',
          ],
          [
            <MockBadge color="orange">Жду ответа</MockBadge>,
            'WAITING — вручную, пока поставщик молчит',
          ],
          [
            <MockBadge color="orange">Нужна инфо</MockBadge>,
            'NEEDS_INFO — нужны уточнения от менеджера или клиента',
          ],
          [
            <MockBadge color="green">Проквотирована</MockBadge>,
            'QUOTED — автоматически после создания квоты',
          ],
          [
            <MockBadge color="gray">Поставщик не ответил</MockBadge>,
            'NO_RESPONSE — вручную, если поставщик так и не ответил',
          ],
          [
            <MockBadge color="red">Отказ</MockBadge>,
            'REFUSED — поставщик отказался работать с этой позицией',
          ],
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как менять:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>В очереди закупки рядом с позицией — дропдаун с доступными MANUAL-значениями</li>
            <li>На странице позиции — поле «Состояние закупщика» в верхней панели</li>
            <li>QUOTED и REQUESTED ставятся автоматически — вручную их не выбрать</li>
          </ul>
          <p className="mt-2">
            Финальные состояния (QUOTED / NO_RESPONSE / REFUSED) сигнализируют что вы по этой
            позиции отработали. По ним считается прогресс «закупка завершена» по заявке.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function QueueCompletion() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Закупка завершена
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          У каждого закупщика есть персональный флаг «закупка по этой заявке завершена».
          Устанавливается на странице заявки — блок «Статус просчёта закупки». Менеджер при этом
          получает уведомление.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Когда нажимать:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Все ваши позиции в финальных состояниях — QUOTED, NO_RESPONSE или REFUSED</li>
            <li>Вы решили, что больше по этой заявке поставщиков искать не будете</li>
            <li>
              Менеджер увидит ваш блок в «Статусе просчёта закупки» и поймёт, что от вас он ждать
              новых цен не должен
            </li>
          </ul>
          <p className="mt-2">
            Флаг можно снять обратно — например, если поставщик внезапно ответил после долгой паузы.
            Снятие флага уведомление не создаёт.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function QueueTake() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Взять в работу
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Процесс взятия позиций в работу через Excel — основной рабочий цикл закупщика.
        </p>
      </div>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">Пошаговый процесс:</div>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300 flex items-center justify-center text-xs font-bold">
                1
              </span>
              <div>
                <div className="font-medium text-gray-800 dark:text-gray-200">Выберите позиции</div>
                <div className="text-xs mt-0.5">Отметьте чекбоксами нужные строки в очереди</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300 flex items-center justify-center text-xs font-bold">
                2
              </span>
              <div>
                <div className="font-medium text-gray-800 dark:text-gray-200">Скачайте запрос</div>
                <div className="text-xs mt-0.5">
                  Кнопка «Скачать запрос» → окно «Кому отправляем запрос?» → отметьте чекбоксами
                  одного или нескольких поставщиков → на каждого формируется свой Excel-файл (BOM).
                  По каждой позиции сразу создаётся квота-«заготовка» без цены
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300 flex items-center justify-center text-xs font-bold">
                3
              </span>
              <div>
                <div className="font-medium text-gray-800 dark:text-gray-200">
                  Отправьте поставщику
                </div>
                <div className="text-xs mt-0.5">
                  Перешлите Excel поставщику по email. Он заполнит цены в тех же строках
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 flex items-center justify-center text-xs font-bold">
                4
              </span>
              <div>
                <div className="font-medium text-gray-800 dark:text-gray-200">Загрузите ответ</div>
                <div className="text-xs mt-0.5">
                  Кнопка «Загрузить ответ» → выберите заполненный Excel → цены попадают в квоты.
                  Цена больше 0 → реальная квота; цена 0 → «Позиция отсутствует»; пусто → заготовка
                  остаётся пустой
                </div>
              </div>
            </div>
          </div>
        </div>
      </MockCard>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Окно «Кому отправляем запрос?»:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Чекбоксы — можно выбрать нескольких поставщиков сразу, на каждого сгенерируется
              отдельный XLSX-файл. Внизу счётчик: «Выбрано поставщиков: N · файлов будет M»
            </li>
            <li>
              Поле «Добавить нового поставщика» + кнопка «+ Добавить» — новое имя появится в списке
              с пометкой «новый» и сразу отметится чекбоксом
            </li>
            <li>
              «Поиск по уже сохранённым…» — фильтр списка подсказок (поставщики из ваших квот и
              предыдущих запросов)
            </li>
            <li>
              Крестик у поставщика («Убрать из списка») — скрывает подсказку лично у вас; сам
              поставщик и его квоты не трогаются. Понадобился снова — введите имя в поле «Добавить
              нового поставщика»
            </li>
            <li>
              Кнопка «Без поставщика» — скачать Excel без привязки: запрос не регистрируется на
              сервере, статусы позиций не меняются
            </li>
            <li>
              Поле «Производитель (прямой запрос — эксклюзив на канал)» — отдельный BOM
              производителю с проверкой занятости канала, см. подраздел «Запрос производителю»
            </li>
          </ul>
        </div>
      </MockCard>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Если по позиции все отправленные поставщикам запросы отвечены и все — ценой 0, позиция
          автоматически переходит в статус «Не найдено». Появление реальной цены вернёт её в работу.
        </div>
      </MockCard>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          <div className="font-medium text-gray-800 dark:text-gray-200 mb-1">
            Формат Excel-ответа:
          </div>
          <p>
            Система читает столбцы: <span className="font-mono text-xs">B</span> (поставщик),
            <span className="font-mono text-xs ml-1">C</span> (партномер),
            <span className="font-mono text-xs ml-1">E</span> (цена),
            <span className="font-mono text-xs ml-1">G</span> (комментарий). Формат цены:{' '}
            <span className="font-mono text-xs">1.44</span>,
            <span className="font-mono text-xs ml-1">1,55</span>,
            <span className="font-mono text-xs ml-1">1 233.33</span> — все поддерживаются.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function QueueManufacturer() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Запрос производителю
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          В окне «Кому отправляем запрос?» есть поле «Производитель (прямой запрос — эксклюзив на
          канал)». Впишите имя производителя — на него сформируется отдельный BOM-файл. Канал
          «производитель» по каждой позиции эксклюзивен на всю компанию: пока прямой запрос открыт,
          его держит один закупщик.
        </p>
      </div>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Как работает эксклюзив:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Позиции, которые уже занял коллега, в ваш BOM производителю не попадут — после
              скачивания придёт отчёт: какие позиции не вошли, кто и когда отправил по ним прямой
              запрос
            </li>
            <li>
              Обычных поставщиков эксклюзив не касается — им можно отправлять запросы по тем же
              позициям параллельно
            </li>
            <li>
              Свои занятые позиции не блокируют повторное скачивание — вы можете отправить запрос
              тому же производителю ещё раз
            </li>
            <li>
              В очереди занятая позиция помечена жёлтой меткой «Произв.» рядом с артикулом —
              наведение показывает, кто и когда занял канал
            </li>
          </ul>
        </div>
      </MockCard>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Как освобождается канал:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Автоматически — когда позиция уходит в счёт или заказ (статусы «Счёт» /«Заказ»),
              снимать ничего не нужно
            </li>
            <li>
              Вручную — РОЗ или ADMIN кликом по метке «Произв.» в очереди: подтверждение «Снять
              запрос производителю?» → канал свободен, прямой запрос сможет отправить другой
              закупщик. Нужно, если закупщик уволился или канал завис
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function QueueHide() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Скрытие позиций (только ГД)
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Генеральный директор может убирать просмотренные позиции из своей очереди квот —
          «просмотрел и скрыл у себя». У других пользователей и в заявках при этом ничего не
          меняется: позиция, квоты и чужие очереди не трогаются.
        </p>
      </div>

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как пользоваться:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Выделите строки чекбоксами → появится кнопка{' '}
              <MockButton variant="secondary">Скрыть у себя (N)</MockButton> — позиции пропадут из
              вашей очереди
            </li>
            <li>
              Кнопка <MockButton variant="secondary">Показать скрытые (N)</MockButton> переключает в
              режим просмотра скрытых — жёлтая панель «Скрытые позиции»
            </li>
            <li>
              В этом режиме доступны «Вернуть выделенные», «Вернуть все» и «← В очередь» (выход из
              режима)
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}
